<template>
    <div
        class="md-search broker"
        :class="{
            [layoutState]: true,
            mobile: isMobile,
            'hide-below': hideBelow,
            'for-cms': forCMS,
            'map-search-hide': !showSearchBar,
            'module-in-featured-area-search': page.pageKey === 'featured-area-search',
            'mg-container': page.pageKey === 'featured-area-search'
        }"
        :style="{ marginBottom, paddingTop, ...style }"
        v-if="listingSourceReady"
    >
        <component
            :is="mdSearchBar"
            ref="listingSearch"
            v-if="showSearchBar"
            :searchBarOnly="false"
            @conditionChange="conditionChange"
            :propsToData="dataToSearchBar"
        />
        <SearchResult
            cls="show-search mg-magtop-40 all-screen"
            :hideBelow="hideBelow"
            :mapSearchText="mapSearchText"
            :hideSearchChoose="hideSearchChoose"
            :mapDrawTip="mapDrawTip"
            :showSchool="showSchool"
            :propsToData="dataToSearchResult"
            ref="result"
        />
    </div>
</template>
<script>

import Core from '../index';
import Broker from '../_mixins/broker';
import { colorBlock } from '../../defaultSpacing';
import searchBarMixin from '../../md-search-bar-mixin';
import { getAsyComponent } from '@/common/utils/load-module.js';

export default {
    mixins: [Core, Broker, searchBarMixin('broker')],
    components: {
        SearchResult: getAsyComponent(() =>
            import(
                /*webpackChunkName: 'components/search-result/broker' */
                '../../../components/search-result/broker/index.vue'
            ))
    },
    data: function() {
        return {
            ...colorBlock,
            theme: 'broker'
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return `${(this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) || 0}px`;
        },
        marginBottom() {
            return `${(this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) || 0}px`;
        }
    }
};
</script>
<style lang="scss">
.md-search {
    position: relative;
}
.md-search.map.broker {
    display: flex;
    flex-direction: column;
    flex: 1;
    .md-search-result:not(.big-map) {
        flex: 1;
    }
    &.mobile {
        .md-search-result {
            height: auto !important;
            .map-result-container {
                height: auto !important;
            }
        }
    }
}
.md-search.map.hide-below ~ * {
    display: none;
}
.map-search-hide .map-tool.search {
    display: none;
}
.md-search.for-cms {
    .md-listing-search {
        .md-search-more {
            padding: 20px 0;
            background-color: white;
            .search-by-section {
                .keyword-container {
                    margin-right: 15px;
                    .search-category {
                        border: 1px solid #c6c8d1;
                        border-radius: 4px;
                        .keyword {
                            .search-input {
                                height: 42px;
                            }
                        }
                        .keyword-submit {
                            height: 42px;
                            line-height: 42px;
                        }
                    }
                }
                .search-more {
                    margin-top: 0;
                    .search-detail-wrap {
                        .search-detail-item {
                            height: 36px;
                            line-height: 34px;
                            &.show-list {
                                background-color: #ebecf1;
                            }
                            &:not(:last-child) {
                                margin-right: 15px;
                            }
                            .logo {
                                display: none;
                            }
                            .box-div {
                                border-radius: 4px;
                                &:after {
                                    content: none;
                                }
                            }
                        }
                    }
                    .list-panel {
                        border-radius: 4px;
                        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                        border: solid 1px #c6c8d1;
                    }
                    .range-input-parent {
                        input {
                            border-radius: 4px;
                            box-shadow: inset 0 2px 4px 0 rgba(0, 10, 30, 0.1);
                            border: solid 1px #c6c8d1;
                        }
                    }
                    .more-list {
                        border-radius: 4px;
                        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                        border: solid 1px #c6c8d1;
                        .section-box .selectdown {
                            height: 36px;
                            line-height: 34px;
                            border: solid 1px #e1e2e6;
                            border-radius: 4px;
                            box-shadow: inset 0 2px 4px 0 rgba(0, 10, 30, 0.1);
                        }
                        .keywords-input {
                            border: solid 1px #e1e2e6;
                            border-right: none;
                            border-radius: 4px 0 0 4px;
                            box-shadow: inset 0 2px 4px 0 rgba(0, 10, 30, 0.1);
                        }
                    }
                }
            }
        }
    }
    .md-search-result {
        .search-result-container {
            .search-result-header {
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: space-between;
                margin-bottom: 10px;
                .search-text {
                    width: auto;
                    height: 20px;
                    line-height: 20px;
                    font-size: 14px;
                    margin-bottom: 0;
                }
                .search-choose {
                    height: 20px;
                    border-bottom: none;
                    width: auto;
                    .list-panel {
                        right: 0;
                        left: auto;
                    }
                }
            }
        }
    }
}

.md-search.broker.map.hide-below {
    margin-bottom: 0 !important;
    .comp-pagination {
        margin-bottom: 60px;
    }
}
</style>
